<button
    class="button save-button"
    [disabled]="disabled"
    (click)="save.emit()">
    <mat-icon>{{ icon }}</mat-icon>
    {{ text | translate }}
</button>
